module.exports = __webpack_public_path__ + "img/participants-icon.b99ca08e.svg";